export default "__VITE_ASSET__DqLoBxbd__"